import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetTenantsQuery, useCreateTenantMutation } from '../store/apiSlice';
import { useNotification } from '../contexts/NotificationContext';
import Layout from '../components/Layout';
import './Tenants.css';

const Tenants: React.FC = () => {
  const { showSuccess, showError } = useNotification();
  const { data: tenantsResponse, isLoading: initialLoading } = useGetTenantsQuery();
  const [createTenant, { isLoading: creating }] = useCreateTenantMutation();
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newTenantName, setNewTenantName] = useState('');

  const tenants = tenantsResponse?.data || [];

  const handleCreateTenant = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newTenantName.trim()) return;

    try {
      await createTenant(newTenantName.trim()).unwrap();
      setNewTenantName('');
      setShowCreateForm(false);
      showSuccess('Tenant created successfully');
    } catch (error: any) {
      console.error('Error creating tenant:', error);
      const errorMessage = error.data?.message || error.message || 'Failed to create tenant';
      showError(errorMessage);
    }
  };

  return (
    <Layout>
      <div className="tenants-page">
        <header className="page-header">
          <h1>Tenants</h1>
          <button onClick={() => setShowCreateForm(!showCreateForm)} className="create-button">
            Create Tenant
          </button>
        </header>

      {showCreateForm && (
        <div className="create-form">
          <form onSubmit={handleCreateTenant}>
            <input
              type="text"
              placeholder="Tenant Name"
              value={newTenantName}
              onChange={(e) => setNewTenantName(e.target.value)}
              required
            />
            <div className="form-actions">
              <button type="submit" disabled={creating}>
                {creating ? 'Creating...' : 'Create'}
              </button>
              <button type="button" onClick={() => setShowCreateForm(false)}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="tenants-list">
        {initialLoading ? (
          <div className="loading-indicator">Loading tenants...</div>
        ) : tenants.length === 0 ? (
          <p>No tenants yet. Create your first tenant!</p>
        ) : (
          tenants.map((tenant) => (
            <Link key={tenant.tenantId || `tenant-${tenant.name}`} to={`/tenants/${encodeURIComponent(tenant.tenantId)}`} className="tenant-card">
              <h3>{tenant.name}</h3>
              <p>ID: {tenant.tenantId}</p>
            </Link>
          ))
        )}
      </div>
    </div>
    </Layout>
  );
};

export default Tenants;

